<template>
  <!-- <div class="small">
    <line-chart :chart-data="datacollection"></line-chart>
    <button @click="fillData()">Randomize</button>
  </div> -->
  <div id="data-page">
      <div style="text-align: center">
          <button @click="emit('share')" class="px-4 m-4 share-journey-btn" v-html="$locale.charts.share_journey"></button>
      </div>
      <div v-if="loaded" class="chart-container pb-2 animated fadeInLeft">
        <h4 class="paragraph-title px-3 pt-4" v-html="$locale.charts.week.communityplantingintensity"></h4>
        <line-chart
          :chartdata="chartdata"
          :options="options"/>
      </div>
      <div>
            <h4 class="paragraph-title px-3 pt-4" v-html="$locale.trophyroom.achievements"></h4>
            <div class="text-center lottie-container" style="position: relative;">
                <lottie-player
                    :src="'https://assets2.lottiefiles.com/packages/lf20_L3lMP1.json'"  background="transparent" class="big-lottie-badge"  speed="1"  style="width: 100%; height: 100%;"  loop autoplay >
                </lottie-player>
                <div class="lottie-text-overlay">Lvl: {{lvl}}</div>
                <div v-html="$locale.head.level +': '+$locale.trophyroom.level[lvl].toUpperCase()"></div>
            </div>
      </div>
      <div>
          <h4 class="paragraph-title px-3 pt-4" v-html="locale.about"></h4>
          <div class="paragraph-text px-3 pt-2 bio" v-html="locale.bio"></div>
          <div class="paragraph-text px-3 pt-2 bio" v-html="locale.donation"></div>
          <div class="text-center">
              <img class="w-50 py-4" src="../assets/TFF-logo.png">
          </div>
          <div class="paragraph-text px-3 pt-2 bio" v-html="locale.treesforthefuture"></div>
      </div>
        <div>
          <h4 class="paragraph-title px-3 pt-4 pb-2" v-html="locale.licenses"></h4>
          <h6 class="paragraph-text px-3">@Issey / LottieFiles</h6>
          <h6 class="paragraph-text px-3">@Vinoth E / LottieFiles</h6>
          <h6 class="paragraph-text px-3">@Toni Adegbenro / LottieFiles</h6>
          <h6 class="paragraph-text px-3">@LottieFilez / LottieFiles</h6>
          <h6 class="paragraph-text px-3 pb-2">@Ping Lu / LottieFiles</h6>
        </div>
  </div>
</template>

<script>
    import LineChart from './Chart.js'
    /* eslint-disable no-console*/

    export default {
        name: 'LineChartContainer',
        components: { LineChart },
        data() {
            return {
                loaded: false,
                chartdata: null,
                options: null,
                locale: this.$locale.about,
                lvl: 0,
                lvlRole: this.$locale.trophyroom.level[0].toUpperCase()
            }
        },
        created(){
            if(localStorage.lvl)
                this.lvl = localStorage.lvl
            
            var roleList = this.$locale.trophyroom.level;

            if(roleList[this.lvl])
                this.lvlRole = roleList[this.lvl].toUpperCase()
            else
                this.lvlRole = roleList[roleList.length - 1].toUpperCase()
                
        },
        activated(){
            if(localStorage.lvl)
                this.lvl = localStorage.lvl
            
            var roleList = this.$locale.trophyroom.level;

            if(roleList[this.lvl])
                this.lvlRole = roleList[this.lvl].toUpperCase()
            else
                this.lvlRole = roleList[roleList.length - 1].toUpperCase()
        },
        async mounted () {
            var weeklocale = this.$locale.charts.week;
            var normalweek = 
            [
                weeklocale.sunday,
                weeklocale.monday,
                weeklocale.tuesday,
                weeklocale.wednesday,
                weeklocale.thursday,
                weeklocale.friday,
                weeklocale.saturday,
                weeklocale.sunday
            ]
            this.loaded = false
            try {
                // const { trees } = await fetch('https://us-central1-myapptree-20dac.cloudfunctions.net/getWeeklyTrees')
                let response = await fetch('https://us-central1-myapptree-20dac.cloudfunctions.net/getWeeklyTrees')
                let treejson = await response.json();
                let trees = [];
                let sortedweek = [];

                let dayofweek = (new Date()).getDay();
                let tomorrow = dayofweek + 1;

                //sort weekly data and lables from a week ago to today
                for(let i = tomorrow; i < tomorrow + 7; i++){
                    trees.push((i < 7) ? treejson[i] : treejson[i - 7]);
                    sortedweek.push((i < 7) ? normalweek[i] : normalweek[i - 7]);
                }

                this.chartdata = {
                    labels: sortedweek,
                    datasets: [
                        {
                            // label: weeklocale.last7days,
                            backgroundColor: '#BADC58',
                            borderColor: '#6AB04C',
                            pointBackgroundColor: '#f1f1f1',
                            pointBorderColor: '#6AB04C',
                            data: trees
                        }
                    ]
                }
                this.options = {
                    responsive: true,
                    title: {
                        display: true,
                        text: weeklocale.last7days,
                    },
                    legend:{
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            gridLines: {
                                display:false
                            },
                            ticks: {
                                display:false,
                                beginAtZero: true
                            }
                        }],
                        xAxes: [{
                            gridLines: {
                                display:false
                            },
                            ticks: {
                                callback: function(value, index, values) {
                                    const padding = '    ',
                                    lastValue = values.length - 1;

                                    if (index !== 0 && index !== lastValue) {
                                        return value;
                                    } else if (index) {
                                        return value + padding;
                                    } else {
                                        return padding + value;
                                    }
                                },
                            },
                            // afterBuildTicks: function(axis) {
                            //     console.log(axis);
                            //     axis.margins.left = '-100';
                            //     axis.margins.right = '-100';
                            // },
                        }]
                    }
                };
                this.loaded = true
            } catch (e) {
            console.error(e)
            }
        },
        methods: {
            emit: function(eventname){
                this.$emit(eventname, this.$locale.charts.sharing_text + 'https://play.google.com/store/apps/details?id=com.myappfree.myapptree')
            },
        }
    }
</script>

<style scoped lang="scss">
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
  #line-chart{
      width: 100%!important;
  }
  .share-journey-btn{
        align-self: center;
        color: white;
        background-color: #BADC58;

        display:inline-block;
        padding:0.35em 1.2em;
        border:0.1em solid #FFFFFF;
        /* border-radius:0.12em; */
        border-radius: 1.2em;
        box-sizing: border-box;
        text-decoration:none;
        font-family:'Roboto',sans-serif;
        font-weight:300;
        text-align:center;
        transition: all 0.2s;
  }

  /* On screens that are 992px or less, set the background color to blue */
@media screen and (max-width: 992px) {
  .big-lottie-badge {
    max-width: 30rem;
  }
}

/* On screens that are 600px or less, set the background color to olive */
@media screen and (max-width: 600px) {
  .big-lottie-badge {
    max-width: 20rem;
  }
}

.lottie-text-overlay{
    position: absolute;
    align-self: center;
    width: 100%;
    bottom: 3rem;
    color: white;
    font-size: 4rem;
    font-family: "Comic Sans MS", cursive, sans-serif
}

//   .bio{
//       font-size: 1.2rem;
//       line-height: 1.3rem;
//   }

//   .paragraph-text{
//       color: gray;
//      b &{
//         color: black;  
//       }
//   }
</style>